<template>
    <div class="live-country">
        <div class="region-selector-content w-100">
            <div class="form-group m-0">
                <span class="error-input-container dropdown-with-info-container" v-if="regions">
                    <button class="dropdown-with-info-container--toggle whitespace-nowrap" v-if="selectedRegion">
                        <span class="color-back">{{ selectedRegion.name }}</span>
                    </button>

                    <select class="form-control" v-model="selectedRegionIso" @change="changeRegion">
                        <option :value="region.iso" v-for="(region) in regions">{{ region.name }}</option>
                    </select>
                </span>
            </div>
        </div>
    </div>
</template>

<script>

import cookiesEnum from "@/core/constants/cookiesEnum";
import {removeCookie, setCookie} from "@/core/utils/helpers/cookieHelper";
import {regionIsoEnum} from "@/core/enums/regionIsoEnum";

const data = () => {
    return {
        store: $store,
        selectedRegionIso: regionIsoEnum.GERMANY,
    }
}

function created() {
    const regionPath = process.env.MIX_REGION_PATH

    if (regionPath) {
        this.selectedRegionIso = regionPath;
    }
}

async function changeRegion() {
    await to(api.locale.change(this.selectedRegionIso));

    setCookie(cookiesEnum.REDIRECT_TO_REGION_OVERRIDE, this.selectedRegionIso);

    const preFix = this.selectedRegionIso === 'de' ? '' : `/${this.selectedRegionIso}`;
    window.location.href = `${preFix}${this.postFixPath}`;
}

export default {
    data,
    created,
    props: [
        'postFixPath'
    ],
    computed: {
        ...mapState(['translate']),
        regions() {
            return [
                {name: 'Ich wohne in Österreich', iso: regionIsoEnum.AUSTRIA},
                {name: 'I live in Australia', iso: regionIsoEnum.AUSTRALIA},
                {name: 'Eu moro no Brasil', iso: regionIsoEnum.BRAZIL},
                {name: 'Ich wohne in Deutschland', iso: regionIsoEnum.GERMANY},
                {name: 'Vivo in Italia', iso: regionIsoEnum.ITALY},
                {name: 'I live in the UK', iso: regionIsoEnum.UNITED_KINGDOM},
            ];
        },
        selectedRegion() {
            return this.regions.find(r => r.iso === this.selectedRegionIso)
        }
    },
    methods: {
        changeRegion,
    },
}
</script>
